// extracted by mini-css-extract-plugin
export default {"form-control":"ViewNote_form-control__1b4Du","card":"ViewNote_card__uH+Dn","btn":"ViewNote_btn__ERgh0"};